import ROUTES from '@consts/routes';
import ROLES from '@consts/role';
import API from '@consts/api';
import Vue from "vue";

export default function ({next}) {
  console.log('____HotelAuthenticated____')
  let app = new Vue();
  let user = app.$auth.user('hotelAuth');
  let expireTime = app.$store.state.hotelAuth.expire_time;
  if (user && user.role === ROLES.ROLE_HOTEL_NAME) {
    if (expireTime <= (new Date()).getTime()) {
      return Vue.prototype.$request.get(API.PROFILE.USER).then(() => {
        next()
      }).catch(() => {
      })
    } else {
      return next()
    }
  } else {
    Vue.router.pushByName(ROUTES.HOTEL.AUTH.LOGIN)
  }
}
